module.exports = __webpack_public_path__ + "ClientApp/content/Student_Externship_Masthead.png";